import React, { useState } from 'react';
import { postData } from '../ServerRequest.js';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/LoginForm.module.css';
import { useAuth } from '../context/AuthContext';


const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotPasswordStep, setForgotPasswordStep] = useState('email'); // email, otp, reset
  const [forgotEmail, setForgotEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [forgotError, setForgotError] = useState('');
  const [forgotSuccess, setForgotSuccess] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const reqData = {
      username: email,
      password: password,
    };
    try {
      const resData = await postData('/api/company/login/', reqData);
      console.log('API response:', resData);
      console.log('Response type:', typeof resData);
      console.log('Response structure:', JSON.stringify(resData, null, 2));
      
      if (resData?.data?.data && resData.data.message === "Login success") {
        // Extract the needed data for login
        const userData = {
          ...resData.data.data,
          token: resData.data.data.token
        };
        
        console.log('Extracted user data:', userData);
        // Use auth context to handle login
        login(userData);
        console.log('Login function called');
        navigate('/admin/dashboard');
      } else {
        setError('Invalid email or password.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleForgotPassword = () => {
    setShowForgotPassword(true);
    setForgotPasswordStep('email');
    setForgotError('');
    setForgotSuccess('');
  };

  const handleSendOTP = () => {
    // In a real app, you would verify the email and send an OTP
    setForgotPasswordStep('otp');
    setForgotError('');
    setForgotSuccess('OTP sent to your email!');
  };

  const handleVerifyOTP = () => {
    if (otp === '123456') { // Dummy OTP for demo
      setForgotPasswordStep('reset');
      setForgotError('');
      setForgotSuccess('OTP verified! Set your new password.');
    } else {
      setForgotError('Invalid OTP. Please try again.');
    }
  };

  const handleResetPassword = () => {
    if (newPassword !== confirmPassword) {
      setForgotError('Passwords do not match.');
      return;
    }
    if (newPassword.length < 6) {
      setForgotError('Password must be at least 6 characters.');
      return;
    }
    setForgotSuccess('Password reset successfully! You can now login.');
    setTimeout(() => {
      setShowForgotPassword(false);
      setForgotPasswordStep('email');
      setForgotEmail('');
      setOtp('');
      setNewPassword('');
      setConfirmPassword('');
      setForgotError('');
      setForgotSuccess('');
    }, 2000);
  };

  const closeForgotPassword = () => {
    setShowForgotPassword(false);
    setForgotPasswordStep('email');
    setForgotEmail('');
    setOtp('');
    setNewPassword('');
    setConfirmPassword('');
    setForgotError('');
    setForgotSuccess('');
  };

  return (
    <div className={styles.loginPageWrapper}>
      <div className={styles.loginLogoBar}>
        <img src={"https://main.d34z81njze67ob.amplifyapp.com/assets/logo-D94pH_jU.png"} alt="Logo" className={styles.loginLogoLeft} />
      </div>
      <div className={styles.loginCardWrapper}>
        <div className={styles.lockIconWrapper}>
          <span className={styles.lockIcon}>
            <svg width="38" height="38" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="#f3f4f6"/><path d="M8 11V9a4 4 0 1 1 8 0v2" stroke="#bdbdbd" strokeWidth="2"/><rect x="6" y="11" width="12" height="8" rx="2" fill="#fff" stroke="#bdbdbd" strokeWidth="2"/><circle cx="12" cy="15" r="1.5" fill="#bdbdbd"/></svg>
          </span>
        </div>
        <h2 className={styles.loginTitle}>Sign in</h2>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.input}
              autoComplete="username"
              required
            />
          </div>
          <div className={styles.inputGroup} style={{ position: 'relative' }}>
            <label htmlFor="password">Password *</label>
            <input
              type={passwordVisible ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
              autoComplete="current-password"
              required
            />
            <span
              className={styles.visibilityToggle}
              onClick={togglePasswordVisibility}
              title={passwordVisible ? 'Hide password' : 'Show password'}
              style={{ position: 'absolute', right: 12, top: 38, cursor: 'pointer', fontSize: 18 }}
            >
              {passwordVisible ? '🙈' : '👁️'}
            </span>
          </div>
          <div className={styles.rememberMe}>
            <input
              type="checkbox"
              id="remember"
              checked={remember}
              onChange={() => setRemember(!remember)}
            />
            <label htmlFor="remember">Remember me</label>
          </div>
          {error && <div className={styles.error}>{error}</div>}
          <button type="submit" className={styles.loginButtonBlack} disabled={loading}>
            {loading ? 'Signing in...' : 'SIGN IN'}
          </button>
          <div style={{ textAlign: 'center', marginTop: 18 }}>
            <button type="button" className={styles.forgotLink} onClick={handleForgotPassword}>Forgot password?</button>
          </div>
        </form>
      </div>
      {/* <div className={styles.loginCopyright}>Copyright © Kl Creation 2025.</div> */}

      {/* Forgot Password Modal */}
      {showForgotPassword && (
        <div className={styles.forgotPasswordOverlay}>
          <div className={styles.forgotPasswordModal}>
            <button className={styles.forgotPasswordClose} onClick={closeForgotPassword}>&times;</button>
            <h2 className={styles.forgotPasswordTitle}>Forgot Password</h2>
            
            {forgotPasswordStep === 'email' && (
              <div className={styles.forgotPasswordStep}>
                <p className={styles.forgotPasswordText}>Enter your email address to receive a verification code.</p>
                <div className={styles.inputGroup}>
                  <label>Email Address *</label>
                  <input
                    type="email"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    className={styles.input}
                    placeholder="Enter your email"
                    required
                  />
                </div>
                {forgotError && <div className={styles.error}>{forgotError}</div>}
                <div className={styles.forgotPasswordActions}>
                  <button type="button" className={styles.forgotPasswordBtn} onClick={handleSendOTP}>Send OTP</button>
                  <button type="button" className={styles.forgotPasswordCancel} onClick={closeForgotPassword}>Cancel</button>
                </div>
              </div>
            )}

            {forgotPasswordStep === 'otp' && (
              <div className={styles.forgotPasswordStep}>
                <p className={styles.forgotPasswordText}>Enter the 6-digit code sent to your email.</p>
                <div className={styles.inputGroup}>
                  <label>OTP Code *</label>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className={styles.input}
                    placeholder="Enter 6-digit OTP"
                    maxLength="6"
                    required
                  />
                </div>
                {forgotError && <div className={styles.error}>{forgotError}</div>}
                {forgotSuccess && <div className={styles.success}>{forgotSuccess}</div>}
                <div className={styles.forgotPasswordActions}>
                  <button type="button" className={styles.forgotPasswordBtn} onClick={handleVerifyOTP}>Verify OTP</button>
                  <button type="button" className={styles.forgotPasswordCancel} onClick={() => setForgotPasswordStep('email')}>Back</button>
                </div>
              </div>
            )}

            {forgotPasswordStep === 'reset' && (
              <div className={styles.forgotPasswordStep}>
                <p className={styles.forgotPasswordText}>Set your new password.</p>
                <div className={styles.inputGroup} style={{ position: 'relative' }}>
                  <label>New Password *</label>
                  <input
                    type={newPasswordVisible ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className={styles.input}
                    placeholder="Enter new password"
                    required
                  />
                  <span
                    className={styles.visibilityToggle}
                    onClick={() => setNewPasswordVisible(!newPasswordVisible)}
                    style={{ position: 'absolute', right: 12, top: 38, cursor: 'pointer', fontSize: 18 }}
                  >
                    {newPasswordVisible ? '🙈' : '👁️'}
                  </span>
                </div>
                <div className={styles.inputGroup} style={{ position: 'relative' }}>
                  <label>Confirm Password *</label>
                  <input
                    type={confirmPasswordVisible ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={styles.input}
                    placeholder="Confirm new password"
                    required
                  />
                  <span
                    className={styles.visibilityToggle}
                    onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                    style={{ position: 'absolute', right: 12, top: 38, cursor: 'pointer', fontSize: 18 }}
                  >
                    {confirmPasswordVisible ? '🙈' : '👁️'}
                  </span>
                </div>
                {forgotError && <div className={styles.error}>{forgotError}</div>}
                {forgotSuccess && <div className={styles.success}>{forgotSuccess}</div>}
                <div className={styles.forgotPasswordActions}>
                  <button type="button" className={styles.forgotPasswordBtn} onClick={handleResetPassword}>Reset Password</button>
                  <button type="button" className={styles.forgotPasswordCancel} onClick={() => setForgotPasswordStep('otp')}>Back</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;